import { FiRrInfo } from '@app/assets';
import { Button, Input } from '@app/components';
import { useTranslation } from 'react-i18next';

type PasswordDialogProps = {
  password: string;
  setPassword: (password: string) => void;
  onSubmit: () => void;
  error: string | null;
  onBack: () => void;
};

export const PasswordDialog: React.FC<PasswordDialogProps> = ({ password, setPassword, onSubmit, error, onBack }) => {
  const { t } = useTranslation();
  return (
    <div
      className="md:max-w-[540px] flex flex-col gap-6 px-6 pt-8 pb-14 md:p-12 bg-white rounded-tr-3xl rounded-tl-3xl md:rounded-3xl"
      onClick={(e) => e.stopPropagation()}
      aria-hidden="true"
    >
      <div className="flex flex-col gap-5">
        <div className="flex flex-col gap-3">
          <h2 className="font-bold text-xl text-gray-800">{t('scan.protected.title')}</h2>
          <p className="text-m text-gray-700">{t('scan.protected.description')}</p>
        </div>
        <div className="flex flex-col gap-2">
          <Input
            type="password"
            value={password || ''}
            label={t('scan.protected.passwordLabel')}
            placeholder={t('scan.protected.passwordPlaceholder')}
            onChange={(e) => setPassword(e.target.value)}
            errorMessage={error ? error : undefined}
          />
        </div>
      </div>
      <div className="flex gap-4">
        <Button className="flex-1" variant="outlined" onClick={onBack}>
          {t('scan.protected.cancelButton')}
        </Button>
        <Button className="flex-1" onClick={onSubmit}>
          {t('scan.protected.unlockButton')}
        </Button>
      </div>
      <div className="flex gap-3">
        <FiRrInfo className="text-error shrink-0 top-1" />
        <p className="text-gray-700 text-xs">{t('scan.protected.warning')}</p>
      </div>
    </div>
  );
};
